import { createSelector } from 'reselect';

import { getPopper } from './getPopper';

export const getPopperProps = createSelector(
  getPopper,
  popper => popper.popperProps,
);
